import {useMemo} from "react";
import {ScreenType} from "../../config/ScreenConfig";
import {useSeatConfig} from "../SeatConfigContext";
import {useAspectRatio} from "../../hooks/useAspectRatio";
import {useScreenConfig} from "../ScreenConfigContext";

export default function useScreenFloorDistance()
{
    const { aspectRatio, projectorPosition, type, screenSize, offset, mirrorHeight } = useScreenConfig();
    const aspect = useAspectRatio(aspectRatio);
    const {numRows} = useSeatConfig();

    return useMemo(() => {

        if (type !== ScreenType.UltraShortThrow) {
            if (numRows === 1) {
                return 50;
            }
            return 60
        }


        const screenHeight = screenSize / aspect;
        return projectorPosition.position[1] + screenHeight * (offset - 1) + mirrorHeight;
    }, [type, offset, mirrorHeight, screenSize, aspect, projectorPosition, numRows]);
}
